import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Filter } from '@rivethealth/data/super-table';
import { isEqual } from 'lodash';
import { HookDirective } from '../core/hook';
import { useSubscriptionLatest } from '../core/hooks';
import { FiltersComponent } from './filters.component';

@Component({
  selector: 'advanced-filter-simple-button',
  templateUrl: './advanced-filter-simple-button.component.html',
  styleUrls: ['./advanced-filter-simple-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedFilterSimpleButtonComponent<
  Name extends string,
  T,
> extends HookDirective {
  constructor(
    changeDetector: ChangeDetectorRef,
    private readonly filters: FiltersComponent<{ [K in Name]: Filter<T[]> }>,
  ) {
    super(changeDetector);
  }

  @Input()
  name: Name;

  @Input()
  value: T[];

  @Input()
  text: string;

  @Input()
  active: boolean = true;

  @Output()
  clicked = new EventEmitter<null>();

  get _() {
    const filters = useSubscriptionLatest(this.filters.value, []);
    const selected =
      !!filters && isEqual(filters[this.name].filter, this.value);

    const changeSelected = (value: T[]) =>
      this.filters.changeValue.next({
        name: this.name,
        reduce(filter) {
          const set = new Set(filter.filter);
          set.clear();
          value.forEach(v => set.add(v));
          return {
            ...filter,
            filter: [...set],
          };
        },
      });

    return {
      selected,
      changeSelected,
    };
  }
}
